module.exports = __webpack_public_path__ + "static/media/structure-tone.7ff3818c.png";